module.exports = __webpack_public_path__ + "static/media/京东到家.ffbd755e.png";